import React, { useEffect, useState, useContext } from 'react'
import { getDonation } from './DonationNoLoginService';
import { useParams, useNavigate } from 'react-router-dom';
import { evenRound } from 'util/NumberUtils';
import { formatCurrency } from 'util/Currency';
import { formatDate } from 'util/Date';
import { getDonationStatus } from 'util/Lookup';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { TenantContext } from 'tenant/TenantContext';
import PageContentContainer from 'uiwidgets/PageContentContainer';
import { SecurityContext } from '../../security/SecurityContext';
import { extractError } from 'api/ErrorUtil';
import DonationDetail from 'uiwidgets/donation/DonationDetail';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { CancelButton } from 'uiwidgets/CancelButton';
import _ from "lodash";

const DonationDetailPage = () => {

    const [donation, setDonation] = useState(null);
    const [account, setAccount] = useState(null);
    const [errors, setErrors] = useState({});
    const { donationId } = useParams();
    const { businessConfig } = useContext(TenantContext);
    const secCtx = useContext(SecurityContext);
    const navigate = useNavigate();

    useEffect(() => {

        const fetchDonationDetail = async () => {
            let userAccounts = [{}];
            try {
                let donation = await getDonation(donationId);
                let userAccounts = secCtx.accounts.filter(acc => acc.id === donation.accountId);
                setDonation(donation);
                setAccount(userAccounts[0]);
            } catch (error) {
                let errs = extractError(error);
                console.log(errs)
                setErrors(errs);
            }

        }
        fetchDonationDetail();

    }, []);

    const handleCancel = async (event) => {
        event.preventDefault();
        navigate(-1);
    }
    return (
        <>
            {!_.isEmpty(donation) &&
                <FormContainer>
                    <DonationDetail businessConfig={businessConfig} donation={donation} account={account}/>
                    <Row><Col>&nbsp;</Col></Row>
                    <Row><Col>&nbsp;</Col></Row>
                    <CancelButton label="Go Back" onClick={handleCancel} />

                </FormContainer>}
        </>
    )
}

export default DonationDetailPage